<div
  class="exit-layer-container"
  role="dialog"
  aria-modal="true"
  aria-labelledby="modal-title"
  aria-describedby="modal-subtitle"
  #modalRoot
>
  <div class="header">
    <div class="header__icon-close" tabindex="0" (keydown)="onKeyDown($event, 'close')">
      <ion-icon #closeButton class="verti-close-16" role="button" aria-label="Close" (click)="close()"></ion-icon>
    </div>

    <ion-icon class="header__info-icon verti-info-64"></ion-icon>

    <span class="header__title" id="modal-title">
      {{ title }}
    </span>

    <span class="header__subtitle" id="modal-subtitle" [innerHtml]="description"></span>

    <div class="header__diamond"></div>
  </div>

  <div class="modal-body">
    <qb-ita-button
      #callButton
      tabindex="0"
      buttonPosition="center"
      type="button"
      color="primary"
      size="small"
      (btnClick)="onBtnClick()"
      [label]="btnLabel"
    ></qb-ita-button>
  </div>
</div>
